module.exports = __webpack_public_path__ + "img/notWorking.4851a24.gif";